import api from "../../../utils/api";

const STORAGE_KEY = "hrm_pending_attendance_punches_v1";
const EVENT_NAME = "attendance-queue-changed";
const MAX_ATTEMPTS = 8;

const readQueue = () => {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
};

const writeQueue = (items) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: getAttendanceQueueStatus() }));
};

export const getAttendanceQueueStatus = () => {
  const items = readQueue();
  return {
    pending: items.filter((item) => item.status === "pending").length,
    failed: items.filter((item) => item.status === "failed").length,
    items,
  };
};

export const queueAttendancePunch = (payload) => {
  const items = readQueue();
  const item = {
    id: window.crypto.randomUUID(),
    payload: { ...payload, client_request_id: window.crypto.randomUUID() },
    captured_at: new Date().toISOString(),
    attempts: 0,
    status: "pending",
    last_error: null,
  };
  writeQueue([...items, item]);
  return item;
};

export const flushAttendanceQueue = async () => {
  if (!navigator.onLine) return getAttendanceQueueStatus();

  const items = readQueue();
  const next = [];

  for (const item of items) {
    if (item.status === "failed") {
      next.push(item);
      continue;
    }

    try {
      await api.post("/attendance/punch", {
        ...item.payload,
        queued_at: item.captured_at,
      });
    } catch (error) {
      // A 409 means the original request reached the server before the
      // connection dropped, so replaying it is safe to treat as complete.
      if (error?.response?.status === 409) continue;

      const attempts = item.attempts + 1;
      next.push({
        ...item,
        attempts,
        status: error?.response || attempts >= MAX_ATTEMPTS ? "failed" : "pending",
        last_error: error?.response?.data?.message || "Network connection unavailable",
      });
    }
  }

  writeQueue(next);
  return getAttendanceQueueStatus();
};

export const retryFailedAttendanceQueue = () => {
  writeQueue(readQueue().map((item) => ({
    ...item,
    status: "pending",
    attempts: 0,
    last_error: null,
  })));
  return flushAttendanceQueue();
};

export const clearFailedAttendanceQueue = () => {
  writeQueue(readQueue().filter((item) => item.status !== "failed"));
};

export const ATTENDANCE_QUEUE_EVENT = EVENT_NAME;
